import { Component, OnInit, ElementRef, HostBinding } from '@angular/core';
import {
	Column
} from 'angular-slickgrid';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { SLLayer } from 'src/app/model/sl-layer';
@Component({
	selector: 'app-hyperlink-column',
	templateUrl: './hyperlink-column.component.html',
	styleUrls: ['./hyperlink-column.component.scss']
})
export class HyperlinkColumnComponent implements OnInit {

	constructor(private domNode: ElementRef) { }
	public gid;
	public hasValue = false;
	public value = '';
	public isReady = false;
	@HostBinding('class.stateful') true;
	@HostBinding('class.isReady') get() { return this.isReady; }

	ngOnInit() {
		this.isReady = true;
	}

	SetData(
		cellNode: HTMLElement,
		row: number,
		dataContext: any,
		colDef: Column,
		map: ISLMap,
		layer: SLLayer
	): void {
		this.gid = dataContext.gid;
		this.value = dataContext[colDef.field];
		this.hasValue = false;
		$(this.domNode.nativeElement).toggleClass('hidden', false);
		this.hasValue = true;
	}
}
